<template>
  <div style="margin-top: 23px">
    <el-row :gutter="24">
      <el-col :lg="10" style="float:right">
        <el-card class="box-card" shadow="never" body-style="padding:0">
          <div slot="header" class="clearfix">
            <span class="line-left">{{ $t('dashboard', 'conversionFunnel') }}</span>
            <!-- <div class="clearfix-right" style="float: right">
              <el-select
                v-model="value"
                :placeholder="$t('dashboard', 'pleaseSelect')"
                style="width: 100px"
              >
                <el-option
                  v-for="(item, index) in [$t('dashboard', 'last30Days'), $t('dashboard', 'last7Days')]"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div> -->
          </div>
          <div
            style="height: 324px; position: relative"
            class="d-flex justify-content-center mt20"
          >
            <img
              height="300"
              width="80%"
              src="@/assets/images/loudou.png"
              alt=""
            />
            <p class="look position_a">{{ $t('dashboard', 'browse') }}{{ seeGoodsNum }}</p>
            <p class="palce_order position_a">{{ $t('dashboard', 'placeOrder') }}{{ orderCount }}</p>
            <p class="pay position_a">{{ $t('dashboard', 'payment') }}{{ payCount }}</p>
            <p class="right1 position_a">
              {{ $t('dashboard', 'orderConversionRate') }} <br />
              {{ seeGoodsNumRate }}
            </p>
            <p class="right2 position_a">
              {{ $t('dashboard', 'paymentConversionRate') }} <br />
              {{ orderCountRate }}
            </p>
            <p class="right3 position_a">
              {{ $t('dashboard', 'dealConversionRate') }} <br />
              {{ payCountRate }}
            </p>
          </div>
        </el-card>
      </el-col>
      <el-col :lg="14" style="padding:0">
        <el-col :lg="12" v-if="type == 1 || type == 2">
          <div class="view pa24" style="height: 182px">
            <span style="color: #737f80; font-size: 20px">{{ $t('dashboard', 'orderAmount') }}</span>
            <h1 class="bold">{{ state.orderAmount | formatMoney }}</h1>
          </div>
        </el-col>
        <el-col :lg="12" v-if="type == 1 || type == 2">
          <div class="view pa24" style="height: 182px">
            <span style="color: #737f80; font-size: 20px">{{ $t('dashboard', 'orderCount') }}</span>
                         <h1 class="bold">{{ state.orderCount || 0 }}{{ unitText }}</h1>
          </div>
        </el-col>
        <el-col :lg="(type == 1 || type == 2) ? 12  : 24" :style="{marginTop:(type == 1 || type == 2) && '35px'}">
          <div
            class="view pa24 d-flex flex-column justify-content-between"
            style="height: 182px; position: relative"
          >
            <span style="color: #737f80; font-size: 20px">{{ $t('dashboard', 'performanceTarget') }}</span>
            <div>
              <h2 style="color: #454a4c">
                {{ $t('dashboard', 'dealAmount') }} {{ state.dealMoney | formatMoney }}
              </h2>
              <span style="color: #c0cbcc"
                >{{ $t('dashboard', 'monthlyTarget') }} {{ state.targetMoney | formatMoney }}</span
              >
            </div>
            <div id="chartDiv"></div>
          </div>
        </el-col>
        <el-col :lg="(type == 1 || type == 2) ? 12  : 24" :style="{marginTop:(type == 1 || type == 2) && '35px'}">
          <div
            class="view pa24 d-flex flex-column justify-content-between"
            style="height: 182px; position: relative"
          >
            <span style="color: #737f80; font-size: 20px">{{ $t('dashboard', 'performanceGap') }}</span>
            <div class="d-flex">
              <div>
                <h2 style="color: #454a4c">{{ $t('dashboard', 'remainingAmount') }} {{ state | dealMoney }}</h2>
                                 <span style="color: #c0cbcc"
                   >{{ $t('dashboard', 'monthlyDealCount') }}{{ state.dealOrderCount }}{{ unitText }}</span
                 >
              </div>
            </div>
            <div id="chartDiv2"></div>
          </div>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import i18nMixin from '@/mixins/i18nMixin';
import { getChangeCount } from "@/api/myStatistics";

export default {
  mixins: [i18nMixin],
  data() {
    return {
      dataKeys: [
        { type: 'completed', count: 3, percent:1 },
        { type: 'incomplete', count: 4, percent:2 }
      ],
      data2Keys: [
        { type: 'completed', count: 0, percent:0 },
        { type: 'performanceGap', count: 0, percent:0 }
      ],
      value: "",
      seeGoodsNum: 0,
      orderCount: 0,
      payCount: 0,
      seeGoodsNumRate: "",
      orderCountRate: "",
      payCountRate: "",
      chart: null, // 保存第一个图表实例
      chart2: null, // 保存第二个图表实例
    };
  },
  props: {
    state: {
      type: Object,
      default: () => {},
    },
    type: {
      type: Number,
      default: 1,
          },
    },
    
    computed: {
      // 根据当前语言生成图表数据
      data() {
        return this.dataKeys.map(item => ({
          ...item,
          type: item.type
        }));
      },
      
      // 根据当前语言生成第二个图表数据
      data2() {
        return this.data2Keys.map(item => ({
          ...item,
          type: item.type
        }));
      },
      
      unitText() {
        const currentLanguage = this.$store.state.currentLanguage || 'zh-TW';
        switch (currentLanguage) {
          case 'zh-CN':
            return '单';
          case 'zh-TW':
            return '單';
          case 'en':
            return 'Order';
          default:
            return '单';
        }
      }
    },
  filters: {
    formatMoney(val) {
      return val ? (val / 100).toFixed(2) : 0;
    },
    dealMoney(val) {
      return val.targetMoney <= val.dealMoney
        ? 0
        : (val.targetMoney/100 - val.dealMoney/100).toFixed(2);
    },
  },
  watch: {
    state(val) {
      let arr = JSON.parse(JSON.stringify(val));

      // 更新 dataKeys 中的数据
      this.dataKeys[0].percent = arr.targetMoney ? +((arr.dealMoney / arr.targetMoney).toFixed(2)) : 1;
      this.dataKeys[1].percent = arr.targetMoney ? +((arr.targetMoney - arr.dealMoney) / arr.targetMoney).toFixed(2) : 0;
      this.dataKeys[0].count = +arr.dealMoney.toFixed(2);
      this.dataKeys[1].count = arr.targetMoney ? +(arr.targetMoney - arr.dealMoney).toFixed(2) : 0;

      // 更新 data2Keys 中的数据
      this.data2Keys[0].percent = arr.targetMoney ? +(arr.dealMoney / arr.targetMoney).toFixed(2) : 1;
      this.data2Keys[1].percent = arr.targetMoney ? +((arr.targetMoney - arr.dealMoney) / arr.targetMoney).toFixed(2) : 0;
      this.data2Keys[0].count = +arr.dealMoney.toFixed(2);
      this.data2Keys[1].count = arr.targetMoney ? +(arr.targetMoney - arr.dealMoney).toFixed(2) : 0;
      
      console.log(this.data2Keys[1], 'this.data2Keys[1]');
      
      // 更新类型和百分比
      this.dataKeys[1].type = this.dataKeys[1].percent > 0 ? 'incomplete' : 'exceeded';
      this.dataKeys[1].percent = this.dataKeys[1].percent > 0 ? this.dataKeys[1].percent : -this.dataKeys[1].percent;
      
      this.data2Keys[1].type = this.data2Keys[1].percent > 0 ? 'performanceGap' : 'exceeded';
      this.data2Keys[1].percent = this.data2Keys[1].percent > 0 ? this.data2Keys[1].percent : -this.data2Keys[1].percent;
      
      // 延迟初始化图表，确保数据已准备好
      this.$nextTick(() => {
        this.initComponent();
        this.initComponent2();
      });
    }
  },

  created() {
    this.getChangeCount();
  },
   mounted(){
     setTimeout(()=>{

      },1000)
     
     // 监听语言变化，强制更新组件
     this.$root.$on('language-changed', () => {
       this.initComponent();
       this.initComponent2();
     });
   },
   beforeDestroy() {
     // 组件销毁前清理图表实例
     if (this.chart) {
       this.chart.destroy();
       this.chart = null;
     }
     if (this.chart2) {
       this.chart2.destroy();
       this.chart2 = null;
     }
     
     // 清理事件监听器
     this.$root.$off('language-changed');
   },
  methods: {

    initComponent() {
      try {
        // 验证数据是否准备好
        if (!this.data || this.data.length === 0) {
          console.warn('Chart data not ready, skipping chart initialization');
          return;
        }
        
        // 清除之前的图表实例
        if (this.chart) {
          this.chart.destroy();
          this.chart = null;
        }
        
        // 清除容器内容
        const container = document.getElementById("chartDiv");
        if (container) {
          container.innerHTML = '';
        }
        
        // 确保容器存在
        if (!container) {
          console.warn('Chart container not found');
          return;
        }
        
        // 验证数据有效性
        const validData = this.data.filter(item => 
          item && typeof item.percent === 'number' && !isNaN(item.percent)
        );
        
        if (validData.length === 0) {
          console.warn('No valid chart data available');
          return;
        }
        
        console.log('Chart data:', validData);
        
        this.chart = new Chart({
          container: "chartDiv",
          autoFit: true,
          height: 300,
          width: 300,
        });

        this.chart.data(validData);
        this.chart.coordinate("theta", {
          radius: 0.4,
          innerRadius: 0.7,
        });
        this.chart.legend(false);
        this.chart.tooltip({
          showMarkers: false,
        });
        this.chart.annotation().text({
          position: ["50%", "50%"],
          content: this.$t('dashboard', 'completionRate'),
          style: {
            fontSize: 14,
            fill: "#8c8c8c",
            textAlign: "center",
          },
          offsetY: 0,
        });
        
        // 安全地访问 data2
        if (this.data2 && this.data2[0] && typeof this.data2[0].percent === 'number') {
          this.chart.annotation().text({
            position: ["50%", "50%"],
            content: Math.round(this.data2[0].percent * 100) + "%",
            style: {
              fontSize: 14,
              fill: "#8c8c8c",
              fontWeight: 500,
              textAlign: "center",
            },
            offsetY: 15,
          });
        }
        
        this.chart
          .interval()
          .adjust("stack")
          .position("percent")
          .color('type',['#4484FD','#51CDCB'])
          .tooltip("type*percent", (type, percent) => {
            if (!type || typeof percent !== 'number') {
              return { name: 'N/A', value: '0%' };
            }
            percent = Math.round(percent * 100) + "%";
            return {
              name: this.$t('dashboard', type),
              value: percent,
            };
          });
        
        this.chart.render();
      } catch (error) {
        console.error('Error initializing chart:', error);
        // 清理可能的部分初始化
        if (this.chart) {
          this.chart.destroy();
          this.chart = null;
        }
      }
    },
    initComponent2() {
      try {
        // 验证数据是否准备好
        if (!this.data2 || this.data2.length === 0) {
          console.warn('Chart2 data not ready, skipping chart initialization');
          return;
        }
        
        // 清除之前的图表实例
        if (this.chart2) {
          this.chart2.destroy();
          this.chart2 = null;
        }
        
        // 清除容器内容
        const container = document.getElementById("chartDiv2");
        if (container) {
          container.innerHTML = '';
        }
        
        // 确保容器存在
        if (!container) {
          console.warn('Chart2 container not found');
          return;
        }
        
        // 验证数据有效性
        const validData = this.data2.filter(item => 
          item && typeof item.percent === 'number' && !isNaN(item.percent)
        );
        
        if (validData.length === 0) {
          console.warn('No valid chart2 data available');
          return;
        }
        
        this.chart2 = new Chart({
          container: "chartDiv2",
          autoFit: true,
          height: 300,
          width: 300,
        });

        this.chart2.data(validData);
        this.chart2.coordinate("theta", {
          radius: 0.4,
          innerRadius: 0.7,
        });
        this.chart2.legend(false);
        this.chart2.tooltip({
          showMarkers: false,
        });
        
        // 安全地访问 data2[1]
        if (validData[1] && validData[1].type) {
          this.chart2.annotation().text({
            position: ["50%", "50%"],
            content: this.$t('dashboard', validData[1].type),
            style: {
              fontSize: 14,
              fill: "#8c8c8c",
              textAlign: "center",
            },
            offsetY: 0,
          });
        }
        
        // 安全地访问 data2[1].percent
        if (validData[1] && typeof validData[1].percent === 'number') {
          this.chart2.annotation().text({
            position: ["50%", "50%"],
            content: Math.round(validData[1].percent * 100) + "%",
            style: {
              fontSize: 14,
              fill: "#8c8c8c",
              fontWeight: 500,
              textAlign: "center",
            },
            offsetY: 15,
          });
        }
        
        this.chart2
          .interval()
          .adjust("stack")
          .position("percent")
          .color('type',['#51CDCB','#4484FD'])
          .tooltip("type*percent", (type, percent) => {
            if (!type || typeof percent !== 'number') {
              return { name: 'N/A', value: '0%' };
            }
            percent = Math.round(percent * 100) + "%";
            return {
              name: this.$t('dashboard', type),
              value: percent,
            };
          });
        
        this.chart2.render();
      } catch (error) {
        console.error('Error initializing chart2:', error);
        // 清理可能的部分初始化
        if (this.chart2) {
          this.chart2.destroy();
          this.chart2 = null;
        }
      }
    },
    async getChangeCount() {
      const result = await getChangeCount({
        type: this.type,
        dayNum: this.value,
      });
      const { orderCount, payCount, seeGoodsNum } = result.data;
      this.seeGoodsNum = seeGoodsNum;
      this.orderCount = orderCount;
      this.payCount = payCount;
      this.seeGoodsNumRate = seeGoodsNum
        ? ((orderCount / seeGoodsNum) * 100).toFixed(2) + "%"
        : "0%";
      this.orderCountRate = orderCount
        ? ((payCount / orderCount) * 100).toFixed(2) + "%"
        : "0%";
      this.payCountRate = seeGoodsNum
        ? ((payCount / seeGoodsNum) * 100).toFixed(2) + "%"
        : "0%";
    },
  },
};
</script>

<style lang="scss" scoped>
.bold {
  font-size: 48px;
  font-weight: 700;
  color: #51cbcd;
  margin-top: 39px;
}
#chartDiv,
#chartDiv2 {
  position: absolute;
  bottom: -75px;
  right: -50px;
}
.look,
.palce_order,
.pay {
  color: #fff;
  left: 35%;
  font-size: 14px;
}
.position_a {
  position: absolute;
}
.look {
  top: 10%;
}
.palce_order {
  top: 45%;
}
.pay {
  top: 75%;
}
.right1 {
  right: 20%;
  top: 25%;
  color: #67757c;
  font-size: 14px;
}
.right2 {
  top: 55%;
  right: 25%;
  color: #67757c;
  font-size: 14px;
}
.right3 {
  right: 5%;
  top: 50%;
  color: #67757c;
  font-size: 14px;
}

</style>
